// getNetworkingSummary.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * @typedef {Object} NetworkingSummary
 * @property {string} status networking status
 * @property {Error} error networking error if there is
 * @global
 */

/**
 * Map networking data to summary
 * @kind selector
 * @param {Immutable.Map} {networking} - networking
 * @return {NetworkingSummary} The selected networking summary.
 */
export const getSummary = ({ networking }) => {
  if (!networking) {
    return { status: 'idle', error: null };
  }
  const data = networking.toJS();
  if (null !== data.error) {
    return { status: 'error', error: data.error };
  } else if (data.isFetching) {
    return { status: 'fetching', error: null };
  } else if (data.isFetched) {
    return { status: 'fetched', error: null };
  } else {
    return { status: 'idle', error: null };
  }
};

/**
 * Select networking summary by select path
 *
 * Notice: On SSR rendered html, number in select path (ex: page)
 * will be transformed into string by JSON.stringify. So need to
 * normalize to  by JSONstring for transfering redux store.
 *
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} selectPath - select path.
 * @return {NetworkingSummary} The selected networking summary.
 */
const getNetworkingSummary = createCachedSelector(
  (state, selectPath) =>
    state.getIn(['networkings', ...selectPath.map(p => `${p}`)]),
  networking => getSummary({ networking })
)((state, selectPath) => selectPath.join(':'));

export default getNetworkingSummary;
